export default class FormatHTML {
	contruct() {}
	
	showString(input) {
		var newInput 	= input,
			markup 		= this.formatMarkup(),
            pattern;

		if (newInput !== undefined) {
            for (var i in markup) {
                if (i != '{{{a' && i != '{{{div' && i != '{{{i') {
                    var regex = new RegExp(i, 'gi');

                    newInput = newInput.replace(regex, markup[i]);
                }

                if (i == '{{{div') {
                    pattern = /{{{div/g;

                    newInput = this.formatInternalMarkUp(pattern, newInput, i);
                }

                if (i == '{{{a') {
                    pattern = /{{{a/g;

                    newInput = this.formatInternalMarkUp(pattern, newInput, i);
                }

                if (i == '{{{i') {
                    pattern = /{{{i/g;

                    newInput = this.formatInternalMarkUp(pattern, newInput, i);
                }
            }
        }
		
		return newInput;
	}
	
	formatInternalMarkUp(pattern, newInput, key) {
		var matches = newInput.match(pattern);
			
		for (var a in matches) {
			var sLink = newInput.substr(newInput.indexOf(key), newInput.length);
			
			sLink = sLink.substr(0, sLink.indexOf('}}}') + 3);
								
			var newLink = '<' + sLink.substr(3, sLink.indexOf('}}}') - 3) + '>',
				regex 	= new RegExp(sLink, 'gi');
						
			newInput = newInput.replace(regex, newLink);
		}
		
		return newInput;
	}
	
	formatMarkup() {
		return {
			'{{{p}}}' 		: '<p>',
			'{{{\/p}}}'		: '</p>',
			'{{{h4}}}'		: '<h4>',
			'{{{\/h4}}}'	: '</h4>',
			'{{{u}}}'		: '<u>',
            '{{{\/u}}}'		: '</u>',
			'{{{ul}}}'		: '<ul>',
			'{{{ol}}}'		: '<ol>',
			'{{{li}}}'		: '<li>',
			'{{{\/li}}}'	: '</li>',
			'{{{\/ul}}}'	: '</ul>',
			'{{{\/ol}}}'	: '</ol>',
			'{{{strong}}}'	: '<strong>',
			'{{{\/strong}}}': '</strong>',
			'{{{br}}}'		: '<br />',
			'{{{a'			: '',
			'{{{\/a}}}'		: '</a>',
			'{{{i'			: '',
			'{{{\/i}}}'		: '</i>',
			'{{{div'		: '',
			'{{{\/div}}}'	: '</div>',
            '{{{table}}}'	: '<table>',
            '{{{\/table}}}'	: '</table>',
            '{{{thead}}}' 	: '<thead>',
            '{{{\/thead}}}'	: '</thead>',
            '{{{th}}}' 		: '<th>',
            '{{{\/th}}}'	: '</th>',
            '{{{td}}}' 		: '<td>',
            '{{{\/td}}}'	: '</td>',
            '{{{tr}}}' 		: '<tr>',
            '{{{\/tr}}}'	: '</tr>',
            '{{{tbody}}}' 	: '<tbody>',
            '{{{\/tbody}}}'	: '</tbody>'
		};
	}
}
